export default {
  namespaced  : true,
  state       : {
    method        : 'web',

    isAuthed      : false,

    accessToken   : null,
    expiresIn     : null,
    refreshToken  : null,
    tokenType     : null,

    csrfToken     : null,
  },
  mutations   : {
    setAuthApi(state, payload){
      if((payload.access_token !== undefined) && (payload.access_token !== null)){
        state.isAuthed = true;
      }else{
        state.isAuthed = false;
      }

      if(payload.access_token !== undefined){
        state.accessToken = payload.access_token;
      }

      if(payload.expires_in !== undefined){
        state.expiresIn = payload.expires_in;
      }

      if(payload.refresh_token !== undefined){
        state.refreshToken = payload.refresh_token;
      }

      if(payload.token_type !== undefined){
        state.tokenType = payload.token_type;
      }

      // ローカルストレージにも保存します。
      localStorage.setItem('akibatrical_passport', JSON.stringify(payload));
    },

    setAuthWeb(state, secureToken){
      if((typeof secureToken !== 'undefined') && (secureToken !== null)){
        state.isAuthed = true;
      }else{
        state.isAuthed = false;
      }

      if(typeof secureToken !== 'undefined'){
        state.csrfToken = secureToken;

        // ローカルストレージにCSRFトークンを保存します。
        localStorage.setItem('akibatrical_secure_key', state.csrfToken);
      }

      state.tokenType = 'web';
    },
    
    removeAuth(state){
      state.isAuthed      = false;

      state.accessToken   = null;
      state.expiresIn     = null;
      state.refreshToken  = null;
      state.tokenType     = null;
    },

    resetStore(state){
      state.method        = 'web';
      state.isAuthed      = false;
      state.accessToken   = null;
      state.expiresIn     = null;
      state.refreshToken  = null;
      state.tokenType     = null;
      state.csrfToken     = null;
    }
  },

  actions     : {
    async setAuth(context, payload){
      switch(context.state.method){
        case 'api':
          context.commit('setAuthApi', payload.data);
        break;

        case 'web':
          context.commit('setAuthWeb', payload.data);
        break;
      }
    },

    async logout(context){
      switch(context.state.method){
        case 'web':
          await context.dispatch({type : 'requests/auth/logout'}, {root:true});

          await context.dispatch('clearFrontendLogoutData');
        break;
      }
    },

    async clearFrontendLogoutData(context){
      // ユーザー情報を削除します。
      context.dispatch({
        type : 'user/clearUserAndCharacter'
      }, {root: true});

      context.commit('removeAuth');

      context.dispatch('clearAllLocalStorage');
    },

    async authErrorLogout(context){
      switch(context.state.method){
        case 'web':
          await context.dispatch('logout');
        break;
      }
    },

    clearAllLocalStorage(){
      localStorage.removeItem('akibatrical_passport');
      localStorage.removeItem('akibatrical_secure_key');
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
};
